import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { ProfileTile } from './ProfileTile';
import { ListItem, ListItemText } from '@material-ui/core';
import Divider from '@material-ui/core/Divider';
import List from '@material-ui/core/List';

const useStyles = makeStyles((theme) => ({
  root: {
    height: '100%',
    flexGrow: 1,
    maxWidth: 400,
  },
}));

export const CustomTreeView = ({
  treeViewInfo,
  profileInfo,
  treeViewRender,
  updateTreeView,
  currentUserInfo,
}) => {
  const classes = useStyles();
  const [renderInfo, setRenderInfo] = useState([]);
  const positions = ['LCP', 'LCVP', 'Manager', 'Team Leader', 'Specialist', 'Team Member'];

  function isUserPositionHigh(user1, user2) {
    const user1_pValue = positions.findIndex((p) => p === user1.position);
    const user2_pValue = positions.findIndex((p) => p === user2.position);
    return user1_pValue - user2_pValue;
  }
  const renderingArray = renderInfo.sort(isUserPositionHigh);
  console.log(renderingArray);
  useEffect(() => {
    const renderInformation = [];
    if (treeViewInfo.length !== 0) {
      treeViewInfo.map((item) => {
        const profileDetails = profileInfo.filter((profile) => item.id === profile.id)[0];
        renderInformation.push({ ...item, ...profileDetails });
      });
    }
    setRenderInfo(renderInformation);
  }, [treeViewRender, treeViewInfo]);

  const updateTile = async (data) => {
    const updatedArray = renderingArray;
    updatedArray[data.tileId] = data.data;
    updateTreeView(updatedArray);
  };
  const deleteTile = async (tileId) => {
    const deletedTile = renderingArray[tileId];
    const updatedArray = renderingArray;
    updatedArray.splice(tileId, 1);
    updateTreeView(updatedArray);
  };

  return (
    <List component="nav" className={classes.root} aria-label="mailbox folders">
      {renderingArray.map((tile, tileId) => (
        <React.Fragment>
          <ListItem style={{ padding: 0 }}>
            <ProfileTile
              tile={tile}
              tileId={tileId}
              updateTile={updateTile}
              deleteTile={deleteTile}
              currentUserInfo={currentUserInfo}
            />
          </ListItem>
          {tileId !== renderInfo.length - 1 && <Divider />}
        </React.Fragment>
      ))}
    </List>
  );
};
